import { useState } from 'react';
import Button, { EButtonColors } from 'components/Base/Button';
import { Text } from 'components/Base/Typography';
import { TConvertedToPetAcknowledgmentUI } from 'data/types/animal.types';
import useDeviceType from 'hooks/useDeviceType';
import { SecondaryTextColor } from 'core/CssVariablesLite';
import {
  notRequiredForDisabilityReason,
  notRequiredForDisabilityReplaceReason,
} from '../../../../Shared/AnimalDetails/AnimalOtherInfo/ConversionTabContent/ConversionTabContent.data';

const NotificationInfo = ({
  animal,
}: {
  animal: TConvertedToPetAcknowledgmentUI;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { convertedToPetReason } = animal;
  const { isMobile } = useDeviceType();

  const getConvertedToPetReason = () => {
    if (convertedToPetReason?.includes(notRequiredForDisabilityReason)) {
      return notRequiredForDisabilityReplaceReason;
    }

    return convertedToPetReason;
  };

  return (
    <Text color={SecondaryTextColor}>
      {isExpanded && (
        <>
          <Text color={SecondaryTextColor}>{getConvertedToPetReason()}</Text>
          <Button
            type="text"
            color={EButtonColors.Info}
            onClick={() => setIsExpanded(p => !p)}
          >
            &nbsp; See less
          </Button>
        </>
      )}

      {!isExpanded &&
        !isMobile &&
        (getConvertedToPetReason()?.length > 60 ? (
          <>
            <Text color={SecondaryTextColor}>
              {getConvertedToPetReason().slice(0, 60)}...{' '}
            </Text>
            <Button
              type="text"
              color={EButtonColors.Info}
              onClick={() => setIsExpanded(p => !p)}
            >
              &nbsp; See more
            </Button>
          </>
        ) : (
          <Text>{getConvertedToPetReason()}</Text>
        ))}
      {!isExpanded && isMobile && (
        <Button
          type="text"
          color={EButtonColors.Info}
          onClick={() => setIsExpanded(p => !p)}
        >
          &nbsp; See more
        </Button>
      )}
    </Text>
  );
};

export default NotificationInfo;
